import { render, staticRenderFns } from "./ProfessorList.vue?vue&type=template&id=f707a032&scoped=true"
import script from "./ProfessorList.vue?vue&type=script&lang=ts"
export * from "./ProfessorList.vue?vue&type=script&lang=ts"
import style0 from "./ProfessorList.vue?vue&type=style&index=0&id=f707a032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f707a032",
  null
  
)

export default component.exports